import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { RouterTabsetComponent } from './router-tabset.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [RouterTabsetComponent],
  exports: [RouterTabsetComponent]
})
export class RouterTabsetModule { }
